import { ContainerModule } from '@yandex-int/k-common/typings';
import b from 'b_';
import groupBy from 'lodash/groupBy';
import { Spin } from 'platform-components';
import { SPIN_SIZES } from 'platform-components/constants';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getCurrentYearCourseId } from 'common.components/course/selectors';

import { CourseContainerLessonGroup } from '../__lesson-group/course-container__lesson-group';
import { useModuleLessonsQuery } from '../queries';

import './course-container__lessons.scss';

interface Props {
    containerModule: ContainerModule;
}

export const CourseContainerLessons = ({ containerModule }: Props) => {
    const moduleId = containerModule.module.id;
    const courseId = useSelector(getCurrentYearCourseId)!;
    const lessonsQuery = useModuleLessonsQuery(moduleId, courseId);
    const results = lessonsQuery.data?.results;
    const lessonsGroups = useMemo(() => Object.entries(groupBy(results || [], 'group_name')), [results]);

    return (
        <div className={b('course-container', 'module-content')}>
            {lessonsQuery.isLoading && <Spin center size={SPIN_SIZES.L} />}
            {lessonsQuery.isSuccess &&
                lessonsGroups.map(([groupName, lessons], index) => (
                    <CourseContainerLessonGroup
                        id={`${moduleId}-${index}`}
                        key={groupName}
                        lessons={lessons}
                        name={groupName}
                    />
                ))}
        </div>
    );
};
